import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSingleVisitCard from '../useSingleVisitCard';
import { getVisitCardViewSections } from '../visitCardViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleVisitCard = () => {
  const { t } = useTranslation();
  const { singleItem, loading } = useSingleVisitCard();

  const sections = useMemo(
    () => getVisitCardViewSections(t, singleItem),
    [t, singleItem],
  );

  const pageTitle = singleItem?.title || t('ELENCO INCONTRI');

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update && (
            <Col>
              <Button>
                <Link to={`/leasing/visit_card/${singleItem?.id}/edit`}>
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/leasing/visit_card'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleVisitCard;
